import {
  IAnalyticsDefinition,
  SignupErrorEvent,
  SignupEvent,
  SignupProgressEvent,
  SignupSuccessEvent,
} from '@pharmaplan/common';
import { logEvent, setUserId } from 'firebase/analytics';

class AnalyticsAdapter extends IAnalyticsDefinition {
  init(analytics: any) {
    this.analyticsInstance = analytics;
  }

  logCustomEvent(
    params: SignupEvent | SignupErrorEvent | SignupProgressEvent | SignupSuccessEvent,
  ): void {
    if (!this.analyticsInstance) return;
    const { event, ...rest } = params ?? {};

    logEvent<string>(this.analyticsInstance, event, rest);
  }

  setUser(id: string) {
    if (!this.analyticsInstance) return;

    setUserId(this.analyticsInstance, id);
  }
}

export default new AnalyticsAdapter();
